import './index.css';

export default {
  name: 'Aupload',
  props: {
    value: null,
    data: { type: Array, default: () => null },
    items: { type: Array, default: () => null },
    config: { type: Array, default: () => null },
    option: { type: Array, default: () => null },
    options: { type: Array, default: () => null },
    files: { type: Array, default: () => [] },
    values: { type: Array, default: () => [] },
    default: { type: Array, default: () => [] },
    loading: { type: Boolean, default: () => false },
    size: { type: String, default: () => '2m' },
    action: { type: String, default: () => '#' },
    multiple: { type: Boolean, default: () => true },
    limit: { type: String, default: () => '10' },
    listType: { type: String, default: () => '' }, // picture-card
    autoUpload: { type: Boolean, default: () => false },
    showFileList: { type: Boolean, default: () => true },
  },
  data() {
    return {
      list: [],
      removed: [],
    }
  },
  watch: {
    value(files = null) {
      if (Array.isArray(files)) {
        this.list = files;
      } else if (typeof files == 'object') {
        Object.keys(files).length > 0 && (Object.keys(files).forEach((a, b) => this.list[b] = files[a]));
      }
    },
  },
  methods: {
    upload(a) {
      this.$emit('upload', a);
    },
    change(file = null, files = []) {
      if (this.multiple) {
        if (files.length > 0) {
          let size = files.reduce((a, b) => a.size + b.size);
          let limit = (parseInt(this.size) * 1024) * files.length;
          if ((size / 1024) > limit) {
            this.$message.info(`上传文件超过了${(limit / 1024)}m限制.`);
            this.list = [];
            return false;
          } else {
            let data = {};
            files.forEach(({ raw = null }, d) => raw && (data[`file${(d + 1)}`] = raw));
            if (Object.keys(data).length > 0) {
              this.$emit('input', data);
              this.$emit('change', data);
            }
          }
        }
      } else {
        if ((file.size / 1024) > (parseInt(this.size) * 1024)) {
          this.$message.info(`上传文件超过了${this.size}限制.`);
          this.list = [];
          files = [];
          return false;
        } else {
          const { raw = null } = file;
          if (raw) {
            this.$emit('input', { file: raw });
            this.$emit('change', { file: raw });
          }
        }
      }
    },
    exceed(a) {
      this.$emit('exceed', a);
    },
    remove(file = null) {
      const data = this.options || this.option || this.config || this.items || this.data || [];
      let files = [...data, ...this.files, ...this.values, ...this.default];
      if (files.includes(file)) {
        const { id } = file;
        this.removed.push(id);
        this.$emit('delete', this.removed, file);
      } else this.$emit('remove', this.removed, file);
    },
    review(a) {
      this.$emit('review', a);
    },
    finish(a) {
      this.$emit('finish', a);
    },
  },
  render() {
    const { ...rest } = this.$attrs;
    const data = this.options || this.option || this.config || this.items || this.data || [];
    let files = [...data, ...this.files, ...this.values, ...this.default];
    let attrs = {
      disabled: this.loading,
      'http-request': this.upload,
      'on-change': this.change,
      'on-exceed': this.exceed,
      'on-remove': this.remove,
      'on-preview': this.review,
      'on-success': this.finish,
      ...rest,
    };
    return (
      <div class="a-upload">
        <el-upload
          action={this.action}
          multiple={this.multiple}
          list-type={this.listType}
          limit={parseInt(this.limit)}
          auto-upload={this.autoUpload}
          show-file-list={this.showFileList}
          file-list={[...this.list, ...files]}
          {...{ attrs }}
        >
          <el-button size="small" type="primary">点击上传</el-button>
          {this.$slots.default}
        </el-upload>
      </div>
    );
  }
}